import { useDeck } from '@/app/context/DeckContext/useDeck';
import React, { useState } from 'react';
import FileViewer from './file-viewer/FileViewer';
import DeckAPI from '@/app/api/DeckAPI/DeckAPI';
import { DeckStatus } from '@/app/constants/DeckStatus';
import { ParsedContent } from '@/app/types/Generator/ParsedContent';

interface IProps {
  selectedPages?: number[];
  visibleSize?: string;
  hideCustomOptions?: boolean;
  onParsedContentChange?: (parsedContent: ParsedContent[]) => void;
}

export const ContentViewer = ({
  selectedPages,
  visibleSize = 'md',
  hideCustomOptions,
  onParsedContentChange
}: IProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const [previewImageUrls, setPreviewImageUrls] = React.useState([]);
  const [isLoadingPreviewImages, setIsLoadingPreviewImages] =
    React.useState(false);

  const { selectedDeck } = useDeck();

  React.useEffect(() => {
    if (
      selectedDeck.status === DeckStatus.Ready ||
      selectedDeck.status === DeckStatus.Complete
    ) {
      setIsLoadingPreviewImages(true);
      DeckAPI.getPreviewImages(selectedDeck.id).then((urls) => {
        setPreviewImageUrls(urls);
        setIsLoadingPreviewImages(false);
      });
    }
  }, [selectedDeck.status]);

  if (!selectedDeck) {
    return null;
  }

  return (
    <>
      {selectedDeck.videoId ? (
        <iframe
          className={`hidden ${visibleSize}:block`}
          style={{
            width: 700,
            height: '100%'
          }}
          src={`https://www.youtube.com/embed/${selectedDeck.videoId}`}
        />
      ) : (
        <FileViewer
          loadingMessage={
            isLoadingPreviewImages ? 'Loading File Preview...' : undefined
          }
          width={700}
          pages={previewImageUrls}
          visibleSize={visibleSize}
          fileType={selectedDeck.fileType}
          visiblePages={selectedPages}
          hideCustomOptions={hideCustomOptions}
          onParsedContentChange={onParsedContentChange}
        />
      )}
    </>
  );
};
